var adyenCheckout = require('./checkout/adyen-checkout');
var paymentErrorModal = require('./returns/payment-error-modal');

/**
 * @private
 * @function
 * @description Binds the events of the order, payment pages
 */
function initializeEvents() {
    if (SitePreferences.ADYEN_RETURNS_ENABLED)  {
        adyenCheckout.initReturns();
        paymentErrorModal.initError();
    }
}

var returns = {
    init: function () {
        initializeEvents();
    }
};

module.exports = returns;
